import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import DefaultNavbar from "components/DefaultNavbar/index";
import routes from "routes";
import bgImage from "assets/images/banner.jpg";
import React, { useState, useEffect } from "react";
import LinksRoleTable from "components/LinksRoleTable";

function LinksRoleSettings() {
  const [employeeName, setEmployeeName] = useState("");

  useEffect(() => {
    const datosRecuperados = localStorage.getItem("sesion");

    if (datosRecuperados) {
      const datos = JSON.parse(datosRecuperados);
      setEmployeeName(datos.employeeName || "");
    } else {
      console.log("No session data found in localStorage.");
    }
  }, []);

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "",
          label: employeeName,
          color: "info",
        }}
        sticky
      />
      <MKBox
        minHeight="20vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      ></MKBox>
      <Card
        sx={{
          p: 4,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
            rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <LinksRoleTable />
      </Card>
    </>
  );
}

export default LinksRoleSettings;
